
export enum PathwayMethod {
    Grandfathered = 1,
    Fellowship = 2,
    Practice = 3,
    OtherBoard = 4
}